// This directive shows an area graph of serial input (i.e. scoreboard adapter) activity on a
// BoxCaster.
angular.module('app.directives').directive('appBoxcasterSerialInputGraph', $location =>
    ({
        require: '^^appBoxcasterGraph',
        restrict: 'E',
        scope: {
            statsData: '=',
            boxcasterId: '@'
        },
        controller($scope) {
            $scope.options = {
                renderer: 'multi',
                height: 40,
                min: 0,
                max: 57600
            };
            return $scope.series = [{
                    name: 'Serial bitrate',
                    renderer: 'area',
                    data: [],
                    color: '#00a000'
                },
                {
                    name: 'Serial src present',
                    renderer: 'area',
                    interpolation: 'step-after',
                    data: [],
                    color: '#c080f0'
                }
            ];
        },

        link(scope, element, attrs, appBoxcasterGraph) {
            return appBoxcasterGraph.registerGraphWidthCallback(newWidth =>
                scope.$apply(() => scope.options.width = newWidth)
            );
        },

        template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
    }));


// WEBPACK FOOTER //
// ./directives/boxcaster_serial_input_graph.js